'use client'

/* eslint-disable consistent-return */
/* eslint-disable n/no-callback-literal */

import { useEffect, useState } from 'react'

const OPTIONS = {
  threshold: 0,
}

export const useObserver = (elementId, cb) => {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const element = document.getElementById(elementId)

    if (element) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setIsVisible(oldVisible => {
              if (oldVisible && cb) {
                cb(false)
              }
              return false
            })
          } else {
            setIsVisible(oldVisible => {
              if (!oldVisible && cb) {
                cb(true)
              }
              return true
            })
          }
        })
      }, OPTIONS)

      observer.observe(element)

      return () => {
        observer.disconnect()
      }
    }
  }, [elementId, cb])

  return isVisible
}
